import axios from 'axios'
import router from '../router'
import store from '../store'
import { Message } from 'element-ui'
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  if (localStorage.getItem('access_token')) {
    config.headers['token'] = localStorage.getItem('access_token')
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
  // Do something with response data
  /**
   * 鉴权
   */
  if (response.data.code === 401 || response.data.code === 402) {
    server.removeAuthToken()
    router.replace({ name: 'EventIndex' })
  } else if (!response.data.success) {
    if (response.data.message === 'error') {
      return false
    }
    Message({
      message: response.data.message,
      type: 'error',
      center: true
    })
  }
  return Promise.resolve(response.data)
}, function (error) {
  // Do something with response error
  return Promise.reject(error)
})

class Request {
  /**
   * 服务器请求API
   */
  constructor () {
    console.log('服务请求')
    // this.baseUrl = '/interface/' // 本地测试
    // this.baseUrl = '/app/' // 线上地址
    this.baseUrl = window.location.host.search(/(localhost|\d+\.\d+\.\d+\.\d+)/g) !== -1 ? '/interface/' : '/app/'
    this.share = ''
  }

  /**
   * old version ----------------------------------------------------------------------------------------------------------------------------
   */

  /**
   * 获取事件基本详情
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventDetail (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}`
    return axios.get(url, { params })
  }

  /**
   * 企业概况
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventDetailBrandBrief (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/brandBrief`
    return axios.get(url, { params })
  }

  /**
   * 舆情概况
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventDetailOverview (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/overview`
    return axios.get(url, { params })
  }

  /**
   * 风险点
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventDetailRiskPoint (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/riskPoint`
    return axios.get(url, { params })
  }
  /**
   * 负面变化
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventDetailEmotion (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/emotion`
    return axios.get(url, { params })
  }
  /**
   * 传播趋势
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventDetailTendency (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/tendency`
    return axios.get(url, { params })
  }
  /**
   * 事件点评
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventDetailOpinionList (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/opinionList`
    return axios.get(url, { params })
  }
  /**
   * 口径模块
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetVenationList (params) {
    const url = `${this.baseUrl}venation/intervene/list`
    return axios.get(url, {params})
  }
  /**
   * 事件脉络
   *
   */
  GetEventDetailVenation (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/venation`
    return axios.get(url, { params })
  }
  /**
   * 重要媒体类型
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventImportChannelTypes (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/importChannel/types`
    return axios.get(url, { params })
  }
  /**
   * 重要媒体的事件
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventImportChannelArticles (eventId, channelId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/importChannel/articles/${channelId}`
    return axios.get(url, { params })
  }
  /**
   * 重要媒体的【事件系统】的事件
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEfImportantChannelArticles (eventId, channelName, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/efImportChannel/articles/${channelName}`
    return axios.get(url, { params })
  }
  /**
   * 重要媒体列表
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventImportChannel (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/importChannel`
    return axios.get(url, { params })
  }
  /**
   * 观点分布
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetEventViewPoint (eventId, params) {
    const url = `${this.baseUrl}event/detail/${eventId}/viewpoint`
    return axios.get(url, { params })
  }

  /**
   * 危机列表
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetTopicEventList (topicId, params) {
    const url = `${this.baseUrl}/topic/${topicId}/eventList`
    return axios.get(url, { params })
  }

  /**
   * 危机专题下的研究报告
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetTopicReportList (topicId, params) {
    const url = `${this.baseUrl}/topic/${topicId}/reportList`
    return axios.get(url, { params })
  }

  /**
   * 危机列表筛选标签
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetTopicCondition (topicId, params) {
    const url = `${this.baseUrl}/topic/${topicId}/condition`
    return axios.get(url, { params })
  }

  /**
   * 危机专题详情
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetTopicDetail (topicId) {
    const url = `${this.baseUrl}topic/${topicId}/detail`
    return axios.get(url)
  }

  /**
   * 危机专题列表
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetTopicList (params) {
    const url = `${this.baseUrl}topic/list`
    return axios.get(url, { params })
  }

  /**
   * 获取专题类型名称列表（未隐藏）
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetTopicTypeNameList (params) {
    const url = `${this.baseUrl}topic/topicTypeNameList`
    return axios.get(url, { params })
  }

  /**
   * 首页-危机对比
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetCompareEvent (params) {
    const url = `${this.baseUrl}compare/compareEvent`
    return axios.get(url, { params })
  }
  /**
   * 首页-危机图谱
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetIndexGraph (params) {
    const url = `${this.baseUrl}index/graph`
    return axios.get(url, { params })
  }
  /**
   * 首页- 选项列表
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetIndexFocusOptions (params) {
    const url = `${this.baseUrl}index/focusOptions`
    return axios.get(url, { params })
  }
  /**
   * 首页- 选择行业和风险
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  PutIndexUpdateFocus (data) {
    const url = `${this.baseUrl}index/updateFocus`
    return axios.put(url, data)
  }
  /**
   * 首页-查询行业事件
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetIndustryEvent (params) {
    const url = `${this.baseUrl}index/industryEvent`
    return axios.get(url, { params })
  }
  /**
   * 首页-查询对比事件
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetCompareEventList (params) {
    const url = `${this.baseUrl}index/compareEventList`
    return axios.get(url, { params })
  }
  /**
   * 首页-查询风险库
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  GetCategoryEvent (params) {
    const url = `${this.baseUrl}index/categoryEvent`
    return axios.get(url, { params })
  }

  /**
   * 用户注册
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  registerNormal (data) {
    const url = `${this.baseUrl}register`
    return axios.post(url, data)
    // TODO 成功注册之后调用自动调用登登录接口进行登录
  }

  /**
   * 完善微信注册过程
   *
   * @param {any} data
   * @memberof Request
   */
  registerWechatComplete (data) {

  }

  /**
   * 获取微信登录二维码
   */
  getWechatQrcodeLogin () {
    const url = `${this.baseUrl}public/qrcode`
    return axios.get(url)
  }
  /**
   *微信轮询登陆检测
   *
   * @param {*} data
   * @memberof Request
   */
  checkWechatLoginPoll (scence) {
    const url = `${this.baseUrl}login/wx/check/${scence}`
    return axios.get(url)
      .then(res => {
        if (res.success) {
          if (res.data.check === 1) {
            this.setAuthToken(res.data.data)
          }
        }
        return res
      })
  }

  /**
   * @description wechat轮询
   * @param scence
   * @returns {AxiosPromise<any>}
   */
  checkBindWechatBind (scence) {
    const url = `${this.baseUrl}users/bind-wechat/${scence}`
    return axios.put(url)
  }

  /**
   * 获取注册验证码码
   *
   * @param {any} data
   * @returns
   * @memberof Request
   */
  getRegisterIdentifyCode (data) {
    const url = `${this.baseUrl}register/send/note?phone=${data.phone}`
    return axios.get(url)
  }

  /**
   * @description 获取找回密码验证码
   * @param {any} data
   * @returns
   * @memberof Request
   */
  getResetIdentifyCode (data) {
    const url = `${this.baseUrl}reset/send/note?phone=${data.phone}`
    return axios.get(url)
  }

  /**
   * @description 找回密码
   * @param data
   * @returns {AxiosPromise<any>}
   */
  resetPassword (data) {
    const url = `${this.baseUrl}reset`
    return axios.post(url, data)
  }

  /**
   *  登录
   *  data {
   *    name: 'admin',
   *    password: 123
   *  }
   */
  login (data) {
    let url = `${this.baseUrl}login`
    return axios.post(url, data)
      .then((res) => {
        if (res.success) {
          this.setAuthToken(res.data)
        }
        return res
      })
  }
  /**
   * 退出
   */
  logout () {
    this.removeAuthToken()
  }
  /**
   * 验证信息是否登录
   */
  checkAuthentication () {
    // todo
    // const token = localStorage.getItem('access_token')
    return true
    // return !!token // mock
  }
  /**
   * 设置登录token
   */
  setAuthToken (data) {
    // todo ...
    axios.defaults.headers.common['token'] = data.token
    localStorage.setItem('access_token', data.token)
    localStorage.setItem('access_vip', +data.roleId !== 0)
    localStorage.setItem('access_username', data.userName)
    localStorage.setItem('access_uid', data.userId)
    localStorage.setItem('access_img', data.headUrl)
  }
  /**
   * 移除token
   */
  removeAuthToken () {
    console.log('logout')
    axios.defaults.headers.common['token'] = ''
    localStorage.setItem('access_token', '')
    localStorage.setItem('access_vip', '')
    localStorage.setItem('access_username', '')
    localStorage.setItem('access_uid', '')
    localStorage.setItem('access_img', '')
    localStorage.setItem('username', '')
    store.dispatch('clearUserLogged')
    // todo ...
  }

  /**
   * 更新用户头像
   *
   * @param {*} data
   * @memberof Request
   */
  updateUserAvatar (data) {
    const url = `${this.baseUrl}users/head-img`
    return axios.post(url, data)
  }

  /**
   * 获取我的 vip信息
   *
   * @returns
   * @memberof Request
   */
  getMyVipInformamtion (params) {
    // const url = `${this.baseUrl}vip/info`
    // return axios.get(url)
    const url = `${this.baseUrl}personal/get/event/auth`
    return axios.get(url, {
      params: params
    })
  }

  /**
   * 用户信息
   *
   * @returns
   * @memberof Request
   */
  getUserinfoUserCenter () {
    const url = `${this.baseUrl}users`
    return axios.get(url)
      .then(res => {
        localStorage.setItem('access_vip', res.data.isVip)
        return res
      })
  }

  /** ----------------------------------------------------------------------- rebuild ------------------------------------------------------------------- */
  // 首页
  /**
   * @description 获取移动端事件top10
   * @returns {AxiosPromise<any>}
   */
  getAppEvents () {
    const url = `${this.baseUrl}index/event/top10`
    return axios.get(url)
  }

  /**
   * @description 获取Pc端事件top15
   * @returns {AxiosPromise<any>}
   */
  getPcEvents () {
    const url = `${this.baseUrl}index/event/top15`
    return axios.get(url)
  }

  /**
   * @description 获取首页案例复盘
   * @returns {AxiosPromise<any>}
   */
  getIndexCaseReviews () {
    const url = `${this.baseUrl}index/article/recently`
    return axios.get(url)
  }

  /**
   * @description 文章点击次数update
   * @param params
   * @returns {AxiosPromise<any>}
   */
  updateCaseClicks (params) {
    const url = `${this.baseUrl}articles/${params.id}/clicks`
    return axios.put(url)
  }

  /**
   * @description 获取首页案例动态
   * @returns {AxiosPromise<any>}
   */
  getIndexCaseNews () {
    const url = `${this.baseUrl}index/event/recently`
    return axios.get(url)
  }

  /**
   * @description 获取首页报告动态
   * @returns {AxiosPromise<any>}
   */
  getIndexReportNews () {
    const url = `${this.baseUrl}index/report/recently`
    return axios.get(url)
  }

  /**
   * @description 获取首页对比
   * @returns {AxiosPromise<any>}
   */
  getIndexCompare () {
    const url = `${this.baseUrl}index/event/hot-compare`
    return axios.get(url)
  }
  // 榜单
  /**
   * @description 获取榜单配置
   * @returns {AxiosPromise<any>}
   */
  getRankInfo () {
    const url = `${this.baseUrl}ranks/condition`
    return axios.get(url)
  }

  /**
   * @description 获取事件榜
   * @param params
   * @returns {AxiosPromise<any>}
   */
  getRankEvents (params) {
    const url = `${this.baseUrl}ranks/event`
    return axios.get(url, { params: params })
  }

  /**
   * @description 获取品牌榜
   * @param params
   * @returns {AxiosPromise<any>}
   */
  getRankBrands (params) {
    const url = `${this.baseUrl}ranks/brand`
    return axios.get(url, { params: params })
  }
  // 收藏
  /**
   * @description 收藏、取消收藏案例
   * @param data
   * @returns {AxiosPromise|AxiosPromise<any>}
   */
  changeEventCollect (data) {
    const url = `${this.baseUrl}collects/event/${data.id}`
    if (data.collect) {
      return axios.post(url)
    } else {
      return axios.delete(url)
    }
  }

  /**
   * @description 收藏、取消收藏报告
   * @param data
   * @returns {AxiosPromise|AxiosPromise<any>}
   */
  changeReportCollect (data) {
    const url = `${this.baseUrl}collects/report/${data.id}`
    if (data.collect) {
      return axios.post(url)
    } else {
      return axios.delete(url)
    }
  }
  // 案例集锦
  /**
   * @description 获取案例集锦筛选条件
   * @returns {AxiosPromise<any>}
   */
  getEventsCondition () {
    const url = `${this.baseUrl}events/condition`
    return axios.get(url)
  }

  /**
   * @description 获取案例列表
   * @param params
   * @returns {AxiosPromise<any>}
   */
  getCaseCollection (params) {
    const url = `${this.baseUrl}events`
    return axios.get(url, { params: params })
  }
  // 报告下载
  /**
   * @description 获取报告下载筛选条件
   * @returns {AxiosPromise<any>}
   */
  getReportsCondition () {
    const url = `${this.baseUrl}reports/condition`
    return axios.get(url)
  }

  /**
   * @description 获取报告
   * @param params
   * @returns {AxiosPromise<any>}
   */
  getReports (params) {
    const url = `${this.baseUrl}reports`
    return axios.get(url, { params: params })
  }

  /**
   * @description 获取报告案例复盘
   * @returns {AxiosPromise<any>}
   */
  getReportsArticles () {
    const url = `${this.baseUrl}reports/articles`
    return axios.get(url)
  }
  // 个人中心
  /**
   * @description 获取用户收藏案例
   * @param params
   * @returns {AxiosPromise<any>}
   */
  getUserEvents (params) {
    const url = `${this.baseUrl}collects/events`
    return axios.get(url, { params: params })
  }

  /**
   * @description 获取用户收藏报告
   * @param params
   * @returns {AxiosPromise<any>}
   */
  getUserReports (params) {
    const url = `${this.baseUrl}collects/reports`
    return axios.get(url, { params: params })
  }

  /**
   * @description 修改用户信息 email headUrl industry name
   * @param data
   * @returns {AxiosPromise<any>}
   */
  updateUsers (data) {
    const url = `${this.baseUrl}users`
    return axios.put(url, data)
  }

  /**
   * @description 微信解绑
   * @returns {AxiosPromise<any>}
   */
  unbindWechat () {
    const url = `${this.baseUrl}users/unbind-wechat`
    return axios.put(url)
  }

  /**
   * @description 修改密码
   * @param data
   * @returns {AxiosPromise<any>}
   */
  checkPassword (data) {
    const url = `${this.baseUrl}users/pwd`
    return axios.put(url, data)
  }

  /**
   * ============================================================================================================ 案例分析
   */
  /**
   * @description 获取分享标识
   * @param share
   */
  getShare (share) {
    this.share = share
    // console.log(this.share)
  }
  /**
   * @description 获取事件详情
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getEventDetail (data) {
    const url = `${this.baseUrl}events/${data.id}/detail`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }

  /**
   * @description 获取事件概览
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getEventOverview (data) {
    const url = `${this.baseUrl}events/${data.id}/overview`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }
  /**
   * @description 获取危机图谱
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getCrisisGraph (params) {
    const url = `${this.baseUrl}graph`
    return axios.get(url, { params })
  }
  /**
   * @description 获取learningList
   * @param eventId
   */
  getEventLearning (eventId, share) {
    const url = `${this.baseUrl}event/detail/${eventId}/learning`
    if (share) {
      return axios.get(url, { params: { share: share } })
    } else {
      return axios.get(url)
    }
  }
  /**
   * @description
   * @param eventId
   */
  getEventSummary (eventId, share) {
    const url = `${this.baseUrl}event/detail/${eventId}/summary`
    if (share) {
      return axios.get(url, { params: { share: share } })
    } else {
      return axios.get(url)
    }
  }

  /**
   * @description 获取事件脉络
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getEventVenation (data) {
    const url = `${this.baseUrl}events/${data.id}/venation`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }

  /**
   * @description 获取传播趋势指标
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getEventTendencyQuota (data) {
    const url = `${this.baseUrl}events/${data.id}/spread`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }

  /**
   * @description 获取传播趋势图
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getEventTendency (data) {
    const url = `${this.baseUrl}events/${data.id}/spread/line`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }

  /**
   * @description 获取事件网民观点
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getEventUserViews (data) {
    const url = `${this.baseUrl}events/${data.id}/comments`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }

  /**
   * @description 获取事件媒体观点
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getEventMediaViews (data) {
    const url = `${this.baseUrl}events/${data.id}/group`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }

  /**
   * @description 获取事件回应
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getEventIntervene (data) {
    const url = `${this.baseUrl}events/${data.id}/intervene`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }

  /**
  * @description 获取渠道解读
  * @param data
  * @returns {AxiosPromise<any>}
  */
  getEventChannelSummary (data) {
    const url = `${this.baseUrl}events/${data.id}/channel-summary`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }

  /**
   * @description 获取渠道类型
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getEventChannelType (data) {
    const url = `${this.baseUrl}events/${data.id}/channel-type/${data.type}`
    if (this.share) {
      return axios.get(url, { params: { share: this.share } })
    } else {
      return axios.get(url)
    }
  }

  /**
   * @description 获取渠道
   * @param data
   * @param params
   * @returns {AxiosPromise<any>}
   */
  getEventChannel (data, params) {
    const url = `${this.baseUrl}events/${data.id}/channel`
    if (this.share) {
      let obj = Object.assign({}, params, { share: this.share })
      return axios.get(url, { params: obj })
    } else {
      return axios.get(url, { params: params })
    }
  }
  /**
    * ============================================================================================================ 对比
    */
  /**
   *获取对比事件简介
   *
   * @param {*} params
   * @returns
   * @memberof Request
   */
  getCompareDetail (params) {
    const url = `${this.baseUrl}compare/detail`
    return axios.get(url, {
      params: params
    })
  }

  /**
   *获取传播趋势对比
   *
   * @param {*} params
   * @returns
   * @memberof Request
   */
  getCompareSpread (params) {
    const url = `${this.baseUrl}compare/spread`
    return axios.get(url, {
      params: params
    })
  }

  /**
   *获取媒体报道对比
   *
   * @param {*} params
   * @returns
   * @memberof Request
   */
  getCompareReport (params) {
    const url = `${this.baseUrl}compare/report`
    return axios.get(url, {
      params: params
    })
  }

  /**
   *获取公关对比
   *
   * @param {*} params
   * @returns
   * @memberof Request
   */
  getCompareIntervene (params) {
    const url = `${this.baseUrl}compare/intervene`
    return axios.get(url, { params: params })
  }

  /**
   *获取指标对比
   *
   * @param {*} params
   * @returns
   * @memberof Request
   */
  getCompareIndicator (params) {
    const url = `${this.baseUrl}compare/indicator`
    return axios.get(url, { params: params })
  }

  /**
   *获取共同媒体参与对比
   *
   * @param {*} params
   * @returns
   * @memberof Request
   */
  getCompareChannel (params) {
    const url = `${this.baseUrl}compare/channel`
    return axios.get(url, { params: params })
  }

  /**
   *获取共同媒体参与对比
   *
   * @param {*} params
   * @returns
   * @memberof Request
   */
  getCompareArticles (params) {
    const url = `${this.baseUrl}compare/channel/articles`
    return axios.get(url, { params: params })
  }
  /**
    * ============================================================================================================ 搜索
    */
  /**
    * @description 搜索危机
    * @param params
    * @returns {AxiosPromise<any>}
    */
  getSearchEvents (params) {
    const url = `${this.baseUrl}search/events`
    return axios.get(url, { params: params })
  }

  /**
    * @description 搜索报告
    * @param params
    * @returns {AxiosPromise<any>}
    */
  getSearchReports (params) {
    const url = `${this.baseUrl}search/reports`
    return axios.get(url, { params: params })
  }

  /**
    * @description 最新动态top5
    * @returns {AxiosPromise<any>}
    */
  getOnlineTop5 () {
    const url = `${this.baseUrl}search/event/online-top5`
    return axios.get(url)
  }
}

const server = new Request()

/* eslint-disable no-new */
export default server



// WEBPACK FOOTER //
// ./src/pages/index/server/server.js